export const ONLY_NUMBER = {
  apply: (value) => value.replace(/\D/g, ''),
};

export const CPF = {
  apply: (value) => value
    .replace(/\D/g, '')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d{1,2})/, '$1-$2')
    .replace(/(-\d{2})\d+?$/, '$1'),
};

export const CNPJ = {
  apply: (value) => value
    .replace(/\D/g, '')
    .replace(/(\d{2})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d{1,2})/, '$1/$2')
    .replace(/(\d{4})(\d)/, '$1-$2')
    .replace(/(-\d{2})\d+?$/, '$1'),
};

export const CPFCNPJ = {
  apply: (value) => (value.length <= 14
    ? CPF.apply(value)
    : CNPJ.apply(value)),
};

export const PHONE = {
  apply: (value) => value
    .replace(/\D/g, '')
    .replace(/(\d{2})(\d)/, '($1) $2')
    .replace(/(\d{5})(\d)/, '$1-$2')
    .replace(/(-\d{4})(\d+?)$/, '$1'),
};

export const CEP = {
  apply: (value) => value
    .replace(/\D/g, '')
    .replace(/(\d{5})(\d)/, '$1-$2')
    .replace(/(-\d{3})(\d+?)$/, '$1'),
};

export const DATE = {
  apply: (value) => value
    .replace(/\D/g, '')
    .replace(/(\d{2})(\d)/, '$1/$2')
    .replace(/(\d{2})(\d)/, '$1/$2')
    .replace(/(\d{4})(\d)/, '$1'),
};

export const NUMBER = {
  stringToModel: (string) => parseFloat(string.replace('R$ ', '').replaceAll('.', '').replace(',', '.')),
  modelToString: (model) => model.toFixed(2).toString(),
  apply: (value) => (value === '' || value === '0,0'
    ? ''
    : new Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2 }).format((value.length <= 3 ? '0,0'.concat(value) : value).replace(/\D/g, '').replace(/(\d)(\d{2})$/g, '$1.$2'))),
};
